/**
 * Resize listener on body
 *
 * Function udates the --vw custom property value to match client width.
 *
 * This property is used where we need 100vw to exclude scrollbar width
 * in order to prevent unnecessary horizontal overflow.
 *
 * NOTE: Overflow-x hidden causes a WCAG fail as some content
 * could flow off screen when text size is enlarged.
 *
 */

function calcInnerWidth() {
  document.body.style.setProperty('--vw', `${document.body.clientWidth}px`);
}

function init() {
  calcInnerWidth();
  window.addEventListener('resize', calcInnerWidth);
}

export default init;
